'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_WebSockets$Opened$() {
}
export { $c_Lpresto_WebSockets$Opened$ as $c_Lpresto_WebSockets$Opened$ };
$p = $c_Lpresto_WebSockets$Opened$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_WebSockets$Opened$;
/** @constructor */
function $h_Lpresto_WebSockets$Opened$() {
}
export { $h_Lpresto_WebSockets$Opened$ as $h_Lpresto_WebSockets$Opened$ };
$h_Lpresto_WebSockets$Opened$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1926712183);
});
$p.l = (function() {
  return "Opened";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Opened";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_WebSockets$Opened$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_WebSockets$Opened$, "presto.WebSockets$Opened$", ({
  Vx: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_WebSockets$Opened$ as $d_Lpresto_WebSockets$Opened$ };
var $n_Lpresto_WebSockets$Opened$;
function $m_Lpresto_WebSockets$Opened$() {
  if ((!$n_Lpresto_WebSockets$Opened$)) {
    $n_Lpresto_WebSockets$Opened$ = new $c_Lpresto_WebSockets$Opened$();
  }
  return $n_Lpresto_WebSockets$Opened$;
}
export { $m_Lpresto_WebSockets$Opened$ as $m_Lpresto_WebSockets$Opened$ };
//# sourceMappingURL=presto.-Web-Sockets$-Opened$.js.map
